import { FeatureFlag } from "@vega-api/extended/auth/featureFlagEnum";
import { getGetFeatureFlagValueMockHandler } from "@vega-api/generated/featureflag-v1/featureflag-v1.msw";
import { getGetFeatureFlagValueResponseMock } from "@vega-api/generated/featureflag-v1/featureflag-v1-mocks.msw";
import { getGetFeatureFlagValueV2AfterAuthMockHandler } from "@vega-api/generated/featureflag-v2/featureflag-v2.msw";
import { type FeatureFlagResponse } from "@vega-api/generated/types/featureFlagResponse";

const featureFlagKeys = [
  "gp_investment_metric_adjustments",
  "gp_trigger_docs_notifications",
  "gp_trigger_offering_docs_notifications",
  "gp_analytics",
  "gp_analytics_subscriptions",
  "device_management",
  "gp_users_resend_invitations",
  "gp_retrigger_email",
  "gp_orgs_linked_users",
  "lp_settings_tab_security",
  "lp_settings_resend_invitations",
  "lp_manage_investment_users",
  "lp_manage_fund_users",
  "lp-edv-enabled",
  "lp-edv-pre-investment-enabled",
  "gp_settings_invite_collaborators",
  "gp_api-gateway_workbench-key-management",
  "gp_case_management",
  "gp_co_investment",
  "lp_co_investment",
  "gp_workbench_documents",
  "maintenance_mode",
  "customer_sentiment_collection",
  "gp_fund_management_gaia",
  "gp_fund_management_gaia_v2",
  "gp_fund_management_fund_by_id_v2",
  "gp_gaia_fund_list_nav",
  "fund_opportunities_page_v2",
  "coinvest_book_build_vd_26153",
  "coinvest_data_room_vd_22599",
  "coinvest_insights_vd-26155",
  "coinvest_outreach_email_vd-27885",
  "coinvest_reporting_vd-26152",
  "coinvest_notifications",
  "coinvest_messaging_vd-28584",
  "gp_coinvest_new_ui_nav_vd-25769",
  "gp_comms_notification_hub",
  "gp_auth_email_preview",
  "lp_capital_activity_investing_entity_label",
] as const;

const customFeatureFlagResponse: FeatureFlagResponse = {
  featureFlagValues: Object.fromEntries(
    featureFlagKeys.map((key) => [key, key !== "maintenance_mode"]),
  ),
};

export const getV1CheckHandler = () =>
  getGetFeatureFlagValueMockHandler(
    getGetFeatureFlagValueResponseMock({
      featureFlagValues: {
        feature_flag_v2: true,
      },
    }),
  );

export const getCustomFeatureFlagHandler = () =>
  getGetFeatureFlagValueV2AfterAuthMockHandler(customFeatureFlagResponse);

export const getDemoFeatureFlagHandler = () =>
  getGetFeatureFlagValueV2AfterAuthMockHandler({
    featureFlagValues: {
      ...customFeatureFlagResponse.featureFlagValues,
      gp_home_tab: true,
    },
  });

export const getAllFeatureFlagsHandler = () =>
  getGetFeatureFlagValueV2AfterAuthMockHandler({
    featureFlagValues: Object.fromEntries(
      Object.values(FeatureFlag)
        .filter(
          (key) =>
            key !== FeatureFlag.MAINTENANCE_MODE &&
            key !== FeatureFlag.SPIKE_NEW_AUTH &&
            key !== FeatureFlag.GP_AUTH_INVITATION_V2 &&
            key !== FeatureFlag.GP_AUTH_UI_CAPABILITIES,
        )
        .map((key) => [key, true]),
    ),
  });
